import React from "react"
import styles from "./blockTitleTextOverlap.module.css"

const BlockTitleTextOverlap = ({ bgColor, data }) => {
  const {
    title,
    text,
    img: {
      uri: { url: image },
    },
  } = data
  return (
    <section className={styles.blockTitleTextOverlap}>
      <div className={styles.blockTitleTextOverlap__text}>
        <h3>{title}</h3>
        <p>{text}</p>
      </div>
      <div className={styles.blockTitleTextOverlap__img}>
        <img src={`https://drupal.smartempo.com/${image}`} alt={title} />
      </div>
    </section>
  )
}
export default BlockTitleTextOverlap
